import script from "./TermQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./TermQuote.vue?vue&type=script&setup=true&lang=js"

import "./TermQuote.vue?vue&type=style&index=0&id=4590ca5a&scoped=true&lang=scss"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4590ca5a"]])

export default __exports__